import { render, staticRenderFns } from "./yuyue_0.vue?vue&type=template&id=3ddbd4e4&scoped=true"
import script from "./yuyue_0.vue?vue&type=script&lang=js"
export * from "./yuyue_0.vue?vue&type=script&lang=js"
import style0 from "./yuyue_0.vue?vue&type=style&index=0&id=3ddbd4e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddbd4e4",
  null
  
)

export default component.exports